import React, { useEffect, useState } from "react";
import "./dashboard.css";
import Sidebar from "../../components/Sidenav/sidenav.components"
import Card from "../../components/Carcard/Carcard";
import DataTable from "../../components/Datatable/Datatable";
import { Certificate } from '../../utils/types';
import { Calendar } from 'primereact/calendar';
import Datepicker from "../../components/Datepicker/Datepicker";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { appInsights, reactPlugin } from '../../utils/appInsights';
import { Col, Row } from "react-bootstrap";
import { Dropdown } from 'primereact/dropdown';
import { validateDateIsBeetween, dateConversion } from "../../utils/formatDate";
import downloadIcon from "../../assets/images/downloadIcon.svg";
import { CarCommonService } from "../../services";
import Loader from '../../components/Loader/loader.components';
import ReportCard from "../../components/ReportCard/reportcard.components";
import { decodeJWT } from "../../utils/commonFns";
import backArrowOutline from "../../assets/images/back-arrow-outline.svg";

interface Column {
  key: keyof Certificate;
  label: string;
}

interface GradeProps {
  Major: number;
  Minor: number;
  Observation: number;
}

const Dashboard = () => {
  const [isAdding, setIsadding] = useState(false);  
  const [data, setData] = useState<Certificate[]>([]);
  const [userName, setUserName] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [dates, setDates] = useState<Date[] | null>(null);
  const [reportdates, setReportDates] = useState<Date[] | null>(null);
  const [reportsData, setReportsData] = useState<Certificate[]>([]);
  const [filteredData, setFilteredData] = useState<Certificate[]>([]); // Initialize with full data
  const [filteredReportData, setFilteredReportData] = useState<Certificate[]>([]); // Initialize with full data
  const [selectedGrade, setSelectedGrade] = useState<string | null>(null); // Track selected grade
  const [selectedReportStatus, setSelectedReportStatus] = useState<string | null>(null); // Track selected report status
  const [gradesCount, setGradesCount] = useState<GradeProps | null>(null);
  const [isCarFilterActive, setIsCarFilterActive] = useState<boolean>(false);
  const [isReportFilterActive, setIsReportFilterActive] = useState<boolean>(false);
  const [rawReports, setRawReport] = useState<any[] | null>(null);
  const [isGradeCardActive, setIsGradeCardActive] = useState<boolean>(false);

  useEffect(() => {
    const token = localStorage.getItem('access_token') as string;
      const decodedToken = decodeJWT(token);
      console.log(decodedToken)
      setUserName(decodedToken.firstName)
  },[])


  const carsTableColumns: Column[] = [
    { key: 'parentCertificate', label: 'Parent Certificate' },
    { key: 'certificateId', label: 'Certificate ID' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'findingId', label: 'Finding ID' },
    { key: 'grade', label: 'Grade' },
    { key: 'status', label: 'Status' },
    { key: 'dueDate', label: 'Due Date' },
  ];

  const reportsTableColumns: Column[] = [
    { key: 'accountName', label: 'Account Name' },
    { key: 'projectName', label: 'Project Name' },
    { key: 'certificateId', label: 'Certificate Type' },
    { key: 'status', label: 'Status' },
    { key: 'auditDate', label: 'Audit Date' },
  ];


  const fetchProjectCarsAndReportsData = (data: any) => {
    const filterAuditDate = (data: any) => {
      const aDate = data.filter((item: any) => item.task_category__c === "Schedule Audit");
      console.log(aDate[0]?.inspire1__Finish_Date_Only__c)
      return aDate[0]?.inspire1__Finish_Date_Only__c;
    }

    if (data) {
      const carsInfo: any[] = [];
      const reportsInfo: any[] = [];
      let reports: any[] = [];
      const counters = {
        Major: 0,
        Minor: 0,
        Observation: 0,
      }

      data.forEach((item: any) => {
        if (item?.Corrective_Action_Requests__r) {
          item?.Corrective_Action_Requests__r?.records.forEach((ele: any) => {
            const allowedStatuses = ["Customer Review", "Evidence Review", "Closed"];
            if (allowedStatuses.includes(ele.Status__c)) {
              carsInfo.push({
                projectName: item?.Name,
                projectId: item?.id,
                id: ele?.id,
                dueDate: ele.Due_Date__c,
                grade: ele.Grade__c,
                status: ele.Status__c,
                certificateId: ele.Related_Certificate_Number__c,
                siteName: ele.Customer_Site__c,
                findingId: ele?.Name,
                parentCertificate: item?.inspire1__Opportunity1__r.Related_Certificate_Number__c,
                opportunityId:  item?.inspire1__Opportunity1__r.id,
                scheme: item?.Program__r?.id,
              })
            }
            
            if (ele.Grade__c === "Major" && ele.status !== "Closed") {
              counters["Major"]++;
            } else if (ele.Grade__c === "Minor" && ele.status !== "Closed") {
              counters["Minor"]++;
            } else if (ele.Grade__c === "Observation" && ele.status !== "Closed") {
              counters["Observation"]++;
            }
          });
        }

        if (item?.Summary_Reports__r) {
          reports = [...reports, ...item?.Summary_Reports__r?.records];
          item?.Summary_Reports__r?.records.forEach((ele: any) => {
            reportsInfo.push({
              projectName:item?.Name	,
              projectId: item?.id,
              id: ele?.id,
              status: ele.Status__c,
              accountName: ele.Account_Name__c,
              auditDate: item.inspire1__Inspire_Tasks__r?.records ? filterAuditDate(item.inspire1__Inspire_Tasks__r?.records) : null,
              certificateId: ele.Certificate_Type__c,
              dueDate: null,
              opportunityId:  item?.inspire1__Opportunity1__r.id,
              opportunityShareFileId: item.ShareFile_Opportunity_Folder__c?.split("/").pop(),
              scheme: item?.Program__r?.name,
            })
          });
        }
      });

      console.log(reportsInfo)
      setData(carsInfo);
      setFilteredData(carsInfo);
      setReportsData(reportsInfo);
      setFilteredReportData(reportsInfo);
      setGradesCount(counters);
      setRawReport(reports);
    }
  }

  const fetchProject = async () => {
    setIsLoading(true);
      CarCommonService.getProjects()
        .then(response => {
          fetchProjectCarsAndReportsData(response.projects);
          setIsLoading(false);
        })
        .catch(error => {
          console.log("error geting projects")
          setIsLoading(false);
        })
  }

  useEffect(() => {
    // fetchData();();
    fetchProject();
  }, []);


  useEffect(() => {
    let newFilteredData = data;
    if (selectedGrade) {
      // Filter by the selected grade
      if (isGradeCardActive) {
        newFilteredData = newFilteredData.filter(item => item.grade && item.grade.toLowerCase() === selectedGrade.toLowerCase() && item.status !== "Closed");
      } else {
        newFilteredData = newFilteredData.filter(item => item.grade && item.grade.toLowerCase() === selectedGrade.toLowerCase());
      }
      setFilteredData(newFilteredData);

    }

    if (dates?.length === 2 && dates[1]) {
      const [fromDate, toDate] = dates;
      newFilteredData = newFilteredData.filter(item => item.dueDate && item.dueDate && validateDateIsBeetween(fromDate, toDate, item.dueDate));
      setFilteredData(newFilteredData);


    }

    if (selectedGrade?.length || dates?.length === 2 && dates[1]) {
      setIsCarFilterActive(true);
    }

    const counters = {
      Major: 0,
      Minor: 0,
      Observation: 0,
    }

    data.forEach((ele: any) => {
      if (ele.grade === "Major" && ele.status !== "Closed") {
        counters["Major"]++;
      } else if (ele.grade === "Minor" && ele.status !== "Closed") {
        counters["Minor"]++;
      } else if (ele.grade === "Observation" && ele.status !== "Closed") {
        counters["Observation"]++;
      }
    })
    setGradesCount(counters);

  }, [dates, data, selectedGrade, isGradeCardActive]);

  useEffect(() => {
    let filteredReportData = reportsData;

    if (selectedReportStatus) {
      filteredReportData = filteredReportData.filter(report => report.status.toLocaleLowerCase() === selectedReportStatus.toLocaleLowerCase());
      setFilteredReportData(filteredReportData);
    }

    if (reportdates?.length === 2 && reportdates[1]) {
      const [fromDate, toDate] = reportdates;
      filteredReportData = filteredReportData.filter(report => report.auditDate && validateDateIsBeetween(fromDate, toDate, report.auditDate));
      setFilteredReportData(filteredReportData);
    }

    if (selectedReportStatus?.length || reportdates?.length === 2 && reportdates[1]) {
      setIsReportFilterActive(true);
    }

  }, [reportdates, reportsData, selectedReportStatus]);

  const handleExport = () => {
    const csvContent = [

      ["Project Id", "Project Name", "Car Id", "Parent Certificate", "Certificate ID", "Site Name", "Finding ID", "Grade", "Status", "Due Date"],
      ...filteredData.map(item => [
        item.projectId || "--",
        item.projectName || "--",
        item.id || "--",
        item.parentCertificate || '--',
        item.certificateId || '--',
        item.siteName || '--',
        item.findingId || '--',
        item.grade || '--',
        item.status || '--',
        item.dueDate || '--',
      ]),
    ]
      .map(e => e.join(","))
      .join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "data_export.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleCardClick = (grade: string) => {
    setSelectedGrade(grade);
    setIsGradeCardActive(true);
    appInsights.trackEvent({ name: `Grade Filter: ${grade}` });
  };

  const carGradeOptions = [
    ...new Set(
      data
        .map((car: any) => car.grade)  // Use projectStatus
        .filter((grade) => grade !== null && grade !== undefined)  // Exclude null and undefined
    ),
  ];

  const reportOptions = [
    ...new Set(
      reportsData
        .map((report: any) => report.status)  // Use projectStatus
        .filter((status) => status !== null && status !== undefined)  // Exclude null and undefined
    ),
  ];


  return (
    <>

      <Sidebar />
      <main className="container-fluid dashboard-bg" >

        <div className="main main-app p-3 p-lg-4">
            <div className="d-flex">
              <h1 className="main-title mb-0">Welcome, {userName}</h1>
              <div className="back-to" onClick={() => window.location.href = `${process.env.REACT_APP_LOGOUT_URL}` as string || ""}><img style={{width: "22px", marginRight: "5px"}} src={backArrowOutline} alt="Upload Icon" className="save-icon" /><div>Go Back To Home</div></div></div>         
          <hr />
          <br />
          <h2 className="mb-3">CARs Information:</h2>
          <div className="row gap-2 g-3 mt-2 mb-2">
            <div className="col pr-0 d-flex justify-content-left">
              <Card
                title="MAJOR CARS"
                count={gradesCount?.Major || 0}
                description="open CARs"
                due=""
                titleColor="#C43131"
                onClick={() => handleCardClick('Major')}
              />
            </div>
            <div className="col pr-0 d-flex justify-content-left">
              <Card
                title="MINOR CARS"
                count={gradesCount?.Minor || 0}
                description="open CARs"
                due=""
                titleColor="#F49632"
                onClick={() => handleCardClick('Minor')}
              />
            </div>
            <div className="col pr-0 d-flex justify-content-left">
              <Card
                title="OBSERVATIONS"
                count={gradesCount?.Observation || 0}
                description="observations"
                due=""
                titleColor="#353535"
                onClick={() => handleCardClick('Observation')}
              />
            </div>
          </div>

          <div className="row g-3">
            <div className="col-12">
              <div className="card p-10">
                <div className="card-body px-0">
                  <Row>
                    <Col md={2} lg={2}>
                      <h4 style={{ fontWeight: 800, color: "#353535" }}>CARs</h4>
                    </Col>
                    <Col md={10}>
                      <div className="d-flex justify-content-end">
                        <Dropdown className="table-status-dropdown" placeholder="Select Grade" autoFocus={false} options={carGradeOptions} value={selectedGrade} onChange={(event: any) => setSelectedGrade(event.value)} />

                        <Calendar
                          className="dhcalander"
                          inputId="dh_calander"
                          placeholder="Filter by date range (due date)"
                          value={dates}
                          onChange={(e: any) => setDates(e.value)}
                          selectionMode="range"
                          readOnlyInput
                          hideOnRangeSelection
                          showIcon
                        />
                        {isCarFilterActive && <button
                          className="btn"
                          style={{ margin: " 0 0 5px 20px", fontSize: "12px", height: "37px", backgroundColor: " rgb(196, 49, 49", color: "#fff" }}
                          onClick={() => {
                            setSelectedGrade('');
                            setDates(null);
                            setFilteredData(data);
                            setIsCarFilterActive(false);
                            setIsGradeCardActive(false);
                          }}
                        >
                          Clear
                        </button>}
                        <button type="button" className="btn btn-secondary bt-export car-download-btn" onClick={handleExport}>
                          Export <img src={downloadIcon} alt="download Icon" className="car-download-icon" />
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  {isLoading ? <div className="alert alert-info">Loading data...</div> :
                    <>
                      {filteredData.length ? (
                        <DataTable initialData={filteredData} columns={carsTableColumns} context="cars" fetchProject={fetchProject}/>
                      ) : (
                        <div className="empty-table-data"><h2>CARs Data Not Available.</h2></div>
                      )}
                    </>
                  }
                </div>

              </div>
            </div>
          </div>

          <br />

          <div className="row g-3">
            <div className="col-12">
              <div className="card p-10">
                <div className="card-body px-0">
                  <Row>
                    <Col md={2} lg={2}>
                      <h4 style={{ fontWeight: 800, color: "#353535" }}>Reports</h4>
                    </Col>
                    <Col md={10}>
                      <div className="d-flex justify-content-end">
                        <Dropdown
                          className="table-status-dropdown"
                          placeholder="Select Status"
                          autoFocus={false}
                          options={reportOptions}
                          value={selectedReportStatus}
                          onChange={(event: any) => setSelectedReportStatus(event.value)}
                        />
                        <Calendar
                          className="dhcalander"
                          inputId="dh_calander_report"
                          placeholder="Filter by date range (due date)"
                          value={reportdates}
                          onChange={(e: any) => setReportDates(e.value)}
                          selectionMode="range"
                          readOnlyInput
                          hideOnRangeSelection
                          showIcon
                        />
                        {isReportFilterActive && <button
                          className="btn btn-danger"
                          style={{ margin: " 0 0 5px 20px", fontSize: "12px", height: "37px", backgroundColor: " rgb(196, 49, 49", color: "#fff"}}
                          onClick={() => {
                            setSelectedReportStatus('');
                            setReportDates(null);
                            setFilteredReportData(reportsData)
                            setIsReportFilterActive(false)
                          }}
                        >
                          Clear
                        </button>}
                      </div>
                    </Col>
                  </Row>
                  <br />
                  {isLoading ? <div className="alert alert-info">Loading data...</div> :
                    <>
                      {filteredReportData.length ? (
                        <DataTable initialData={filteredReportData} columns={reportsTableColumns} rawReports={rawReports} context="reports" />
                      ) : (
                        <div className="empty-table-data"><h2>Reports Data Not Available.</h2></div>
                      )}
                    </>
                  }
                </div>
              </div>
            </div>
          </div>


        </div>

      </main>




    </>
  );
};

export default Dashboard;
